import askGithub from './../../lib/askGithub'
import { setUser } from './actions'
import { addRepository } from './../repositories/actions'
import { addError } from './../errors/actions'
import { addOrganization } from './../organizations/actions'
import ERROR_CODES from './../../lib/errorCodes'
import { setLoading } from './../loading/reducer'
import getUserAndOrgsAndRepos, { getNextRepos } from './../../data/getUserAndOrgsAndRepos'

export default ({ dispatch, getState }) => next => async action => {


  if (action.type == 'LOAD_BASIC_INFO'){

    // Already loading or has been loaded
    if (`basic-info` in getState().loading) return
    dispatch(setLoading('basic-info', true))

    try {
      var {
        user,
        organisations,
        repositories,
        pageInfo
      } = await getUserAndOrgsAndRepos(getState().token, 20)
    } catch (err) {
      dispatch(addError(err))
    }

    // Update the state in batch so that the UI isn't updated for every
    // addition

    dispatch([
      setUser(user),
      ...(organisations.map(o => addOrganization(o))),
      ...(repositories.map(r => addRepository(r))),
    ])

    // Fetch more repoistories if there's more
    while (pageInfo.hasNextPage){
      try {
        var {
          repositories,
          pageInfo
        } = await getNextRepos(getState().token, pageInfo.cursor, 20)
      } catch (err) {
        dispatch(addError(err))
      }
      dispatch(repositories.map(r => addRepository(r)))
    }

    dispatch(setLoading('basic-info', false))


  }
  return next(action)
}



// WEBPACK FOOTER //
// ./src/store/user/middleware.js